// extracted by mini-css-extract-plugin
export default {"dollarInput":"style_dollarInput__58Gti","inputContainer":"style_inputContainer__wFoJj","dollarSign":"style_dollarSign__0dDfc","inputField":"style_inputField__N1ErQ"};